import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=cf917fe4&scoped=true&"
import script from "./ProductList.vue?vue&type=script&lang=js&"
export * from "./ProductList.vue?vue&type=script&lang=js&"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=cf917fe4&lang=scss&scoped=true&"
import style1 from "./ProductList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf917fe4",
  null
  
)

export default component.exports